import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Bus: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 43.39 43.45">
            <g>
                <rect fill="none" x="31.29" y="38.15" width="2.65" height="3.43"/>
                <rect fill="none" x="8.85" y="38.15" width="2.65" height="3.44"/>
                <path fill="none" d="M34.36,1.87H8.96s0-.01,0-.01c-1.27,0-2.31,1.03-2.32,2.31l-.13,14.99.13,17.12h30.12s.06-17.12.06-17.12l-.13-14.99c-.01-1.27-1.05-2.3-2.32-2.31ZM14.93,33.62h-5.5v-1.86h5.5v1.86ZM33.96,33.62h-5.5v-1.86h5.5v1.86ZM33.97,6.21H9.55v-1.86h24.42v1.86Z"/>
                <rect fill={color} x="9.55" y="4.35" width="24.42" height="1.86"/>
                <g>
                    <path fill={color} d="M38.55,4.23v-.06c-.02-2.29-1.9-4.15-4.19-4.15H8.96s0-.01,0-.01c-2.29,0-4.17,1.86-4.19,4.15v.05H0v6.45h1.86v-4.58h2.89l.03,32.08h2.2v5.3h6.38v-5.3h16.06v5.3h6.38v-5.29h2.81s-.04-32.07-.04-32.07h2.96v4.58h1.86v-6.45h-4.84ZM11.5,41.58h-2.65v-3.44h2.65v3.44ZM33.93,41.58h-2.65v-3.43h2.65v3.43ZM36.75,36.29H6.64s0-32.12,0-32.12c.01-1.27,1.05-2.31,2.32-2.31h25.41c1.27.01,2.31,1.04,2.32,2.32l.06,32.11Z"/>
                    <rect fill={color} x="9.43" y="31.76" width="5.5" height="1.86"/>
                    <rect fill={color} x="28.45" y="31.76" width="5.5" height="1.86"/>
                    <polygon fill={color} points="33.6 9.1 9.72 9.1 9.72 26.05 11.58 24.29 11.58 10.96 31.74 10.96 31.74 26.77 11.67 26.77 9.72 28.61 9.72 28.63 33.6 28.63 33.6 9.1"/>
                </g>
            </g>
        </svg>
    );
};

export default Bus;
